import { Injectable } from '@angular/core'
import { environment } from '../environments/environment'
import { sharedEnvironment } from '../environments/shared-environment'

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private _concreteEnv: { [key: string]: any}
  private _sharedEnv: { [key: string]: any}

  constructor() {
    this._concreteEnv = environment
    this._sharedEnv = sharedEnvironment
  }

  public get(name: string) {
    return this._concreteEnv.hasOwnProperty(name) ? this._concreteEnv[name] : this._sharedEnv[name]
  }
}
